/*
 * @Date: 2019-08-20 19:46:56
 * @LastEditors: x
 * @LastEditTime: 2019-08-21 17:04:57
 */
import Vue from 'vue'
import Vuex from 'vuex'
import modules from './modules'
Vue.use(Vuex)

const debug = process.env.NODE_ENV !== 'production'

export default new Vuex.Store({
  modules,
  strict: debug
})


// WEBPACK FOOTER //
// ./src/store/index.js